module.exports = __webpack_public_path__ + "media/images/favicons/ms-icon-70x70-8bfd6ff24c3dbcde4237e403924123b5.png";